module.exports = __webpack_public_path__ + "static/media/3_Heaven and hell_ES.aec4d2b2.txt";